<template>
    <div class="page">
        <div class="page-header">
            <h1>物流方式設定</h1>
        </div>

        <div class="content">
            <div class="placeholder-content">
                <div class="placeholder-icon">
                    <CarOutlined class="text-5xl text-gray-600" />
                </div>
                <h3>物流方式設定功能</h3>
                <p>此功能正在開發中，敬請期待...</p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { CarOutlined } from '@ant-design/icons-vue';
</script>

<style scoped>
.page {
    padding: 24px;
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.95),
        rgba(248, 249, 250, 0.9)
    );
    min-height: 100vh;
}

.page-header {
    margin-bottom: 24px;
}

.page-header h1 {
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 8px 0;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
}

.page-header p {
    margin: 0;
    color: #6a6a7a;
    font-size: 14px;
    font-family: 'Courier New', monospace;
}

.content {
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.95),
        rgba(248, 249, 250, 0.9)
    );
    border: 2px solid transparent;
    border-radius: 16px;
    padding: 32px;
    min-height: 400px;
    position: relative;
    box-shadow: 0 0 30px rgba(42, 74, 122, 0.3);
}

.content::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 16px;
    padding: 2px;
    background: linear-gradient(45deg, #64748b, #2a4a7a, #3b6ea5, #0e7490);
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    -webkit-mask-composite: xor;
}

.placeholder-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 300px;
    text-align: center;
    position: relative;
    z-index: 1;
}

.placeholder-icon {
    margin-bottom: 24px;
}

.placeholder-content h3 {
    font-size: 20px;
    font-weight: 500;
    margin: 0 0 12px 0;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
}

.placeholder-content p {
    margin: 0;
    color: #2a2a3a;
    font-size: 14px;
    font-family: 'Courier New', monospace;
    opacity: 0.8;
}
</style>
